import { ProductSwitchRecordDto } from '@eneco/dc-be/client';

import { canUserSwitchProduct } from './userCanSwitchProduct';

const getSortedProducts = (
  records: ProductSwitchRecordDto[] | undefined | null,
  eanSearchParam: string | null,
  isCurrentAccountReader: boolean,
) => {
  if (!records) return [];
  return [...records]
    .filter(x =>
      canUserSwitchProduct({
        isCurrentAccountReader,
        productSwitchStatus: x.current?.productSwitchStatus,
        hasProductSwitchOptions: !!x.switchOptions?.length,
        isActiveProduct: !!x.current?.isActive,
        isSocialTariff: !!x.current?.hasSocialTarriff,
      }),
    )
    .sort((a, b) => {
      // 1) force the matching EAN to the front
      const aIsMatch = a.current?.ean === eanSearchParam;
      const bIsMatch = b.current?.ean === eanSearchParam;
      if (aIsMatch && !bIsMatch) return -1;
      if (bIsMatch && !aIsMatch) return 1;

      // 2) otherwise, sort by energyType from the matching EAN
      const startingEnergyType = records?.find(x => x.current?.ean === eanSearchParam)?.current?.energyType;

      if (startingEnergyType === 'Gas') {
        return (b.current?.energyType ?? '').localeCompare(a.current?.energyType ?? '');
      }
      return (a.current?.energyType ?? '').localeCompare(b.current?.energyType ?? '');
    });
};

export default getSortedProducts;
